import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';

import { ParameterResult } from '@models/swagger';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';

export interface HomeRegimesParams extends DefaultHttpHeaders {}

@Injectable()
export class HomeRegimesService extends ApiService {
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  /**
   * Service for obtaining home regimes
   * Service for obtaining home regimes
   * https://d2go64w4712gob.cloudfront.net/swagger/apis_trasversales/italia/api_Verti.html#/Catalog/getComeroundHomeRegimes
   */
  homeRegimes(params: HomeRegimesParams): Observable<ParameterResult[]> {
    return this.get<ParameterResult[]>({
      suffix: '/comeround/catalog/homeRegimes',
    });
  }
}
